module.exports = {"id":"213030","name":"Jordan Marié","rating":"73","photo":"./data/images/photos/0/213030.png","club":{"name":"Dijon FCO","logo":"./data/images/clubs/DijonFCO.png"},"positions":["MC","MDC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JordanMarie0.json
// module id = 2133
// module chunks = 0